// extracted by mini-css-extract-plugin
module.exports = {"about":"About_about__1Udax","heading":"About_heading__Sk2ax"};